import React from 'react';
import { Session } from 'api/api-user';
import { Helpers } from '../helpers/helpers';
import ReactDOM from 'react-dom';
import some from 'lodash/some';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import { buildImagePath } from 'config/paths';
import publicConfig from '../../../../public-config';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Navbar } from './navbar';
import SharedIntlProviderHOC from '../hocs/sharedIntlProviderHOC';
import { LocaleSelector } from '../internationalization/locale-selector';
import DropdownMenu from './DropdownMenu';
import { getNavbarBrowsePaths } from './navbar-browse-paths';
import { SearchSmall, ArrowDownSmall } from '../icons';
import { shutdown } from "@intercom/messenger-js-sdk";

export const NavbarBody = injectIntl(({ intl, ...props }) => {
  const {
    hideSearch,
    navTransparentClass,
    userSSOID,
    isHost,
    nuxData = [],
    loggedOut,
    loggedIn,
    envLocaleData,
    noFixedNav,
    messageCount,
    avatarURL,
    displaySearchNav,
    searchActivity,
    searchLocation,
    availablePermalinks,
    toggleSearchWidgetFn
  } = props;

  const zenDeskLocale = SharedIntlProviderHOC.getZendeskLocale();
  const prefix = SharedIntlProviderHOC.getUrlPrefix();
  const urlPrefix = prefix ? `/${prefix}` : '';
  const isBlackListLanguage = 'en-US' !== intl.locale;
  const showReferral = !publicConfig.hideReferral && !isBlackListLanguage && userSSOID && !isHost;
  const showReferralForHost = !publicConfig.hideReferral && !isBlackListLanguage && userSSOID;
  // Listings Page uses it's own fixed navbar. The following code checks to see if the noFixedNav prop is present
  // on Server Side in order to set the main navbar to fixed or not.
  let fixedTop = 'navbar-fixed-top';
  fixedTop = noFixedNav || ('undefined' !== typeof navJSON && navJSON.noFixedNav) ? '' : 'navbar-fixed-top';
  const sendReferralNavClickAnalytics = () => {
    analyticsIntegrations.trackReferralClick('nav');
  };

  const logOutUser = (event) => {
    event.preventDefault();
    const userToken = PSSessions.Cookies('PSAccess');
    Session.destroy(userToken, function destroy (response) {
      var error = response.error;
      if (error && (-1 === error.indexOf('Invalid Access Token'))) {
        console.log(`couldn't log out because ${response.error}`);
      } else {
        shutdown();
        PSSessions.eH.logout();
        analyticsIntegrations.accountLogout();
        const navElement = $('#main-nav');
        const navTransparentClass = navElement.hasClass('navbar-transparent') ? 'navbar-transparent' : '';
        ReactDOM.render(
          <Navbar loggedIn="hide" userSSOID="" messageCount="" isHost=""
            avatarURL="" navTransparentClass={navTransparentClass} loggedOut="" managedAccount=""
            displaySearchNav={navJSON.displaySearchNav}
            hideSearch={navJSON.hideSearch}
            searchActivity={navJSON.searchActivity}
            searchLocation={navJSON.searchLocation}
            locale={navJSON.locale}
            envLocaleData={navJSON.envLocaleData}
          />, document.getElementById('nav-container')
        );
      }
    });
  };

  const checkIsHost = (isBoxMenu) => {
    const listClass = isBoxMenu ? 'visible-menu-item' : 'menu-listings hidden-menu-item';
    const badgeExp = some(nuxData, { name: 'mylistings-new-badge' });

    if (isHost) {
      return (
        <li className={listClass}>
          <a className="nav-link" href="/mylistings">
            <FormattedMessage
              id="shared_component.navba.listings_nav_item"
              defaultMessage="Listings"
            />
          </a>
          {
            badgeExp
              && <span className="v-center text-pale-blue text-small new-notification">
                <FormattedMessage
                  id="shared_component.navbar.notification_nav_badge"
                  defaultMessage="NEW!"
                />
              </span>
          }
        </li>);
    }
  };

  const renderBoards = (isBoxMenu) => {
    const listClass = !isBoxMenu ? 'menu-listings hidden-menu-item' : isHost ? '' : 'visible-menu-item';

    if (!isHost || isBoxMenu) {
      return (
        <li className={listClass}>
          <a href="/boards">
            <FormattedMessage
              id="shared_component.navbar.boards_nav_item"
              defaultMessage="Boards"
            />
          </a>
        </li>
      );
    }
  };

  const checkHideSearch = () => {
    const isMobile = Helpers.isMobile(false, true);
    const loggedIn = ('hide' === loggedOut);
    let searchClass;
    let searchText = intl.formatMessage({ id: 'shared_component.navbar.search_text', defaultMessage: 'Search' });

    if (loggedIn && isMobile) {
      searchClass = '';
    } else if (isMobile) {
      searchClass = 'search-mobile';
      searchText = '';
    } else {
      searchClass = 'pull-left';
    }
    return (
      <li>
        <a
          id="header_link_search"
          className={'search ' + searchClass}
          onClick={() => toggleSearchWidgetFn()}
        >
          <SearchSmall className="margin-sm-right" width={20} height={20} />
          {searchText}
        </a>
      </li>
    );
  };

  const checkHideSignUp = () => {
    const isMobile = Helpers.isMobile(false, true);
    let signUpClass;

    if (isMobile) {
      signUpClass = 'visible-menu-item';
    }
    return (
      <li className={'nav-logged-out ' + props.loggedOut}>
        <a className={'sign-up ' + signUpClass} href="#a=signup&source=nav">
          <FormattedMessage
            id="shared_component.navbar.signup_nav_item"
            defaultMessage="Sign Up"
          />
        </a>
      </li>
    );
  };

  const checkHideVerticalLine = () => {
    const isMobile = Helpers.isMobile(false, true);
    let lineClass = '';

    if (isMobile) {
      lineClass = 'visible-menu-item';
    }

    return (
      <li className={'nav-logged-out ' + loggedOut}>
        <div className={'vertical-line ' + lineClass} />
      </li>
    );
  };

  const checkMessageBubble = () => {
    if (messageCount) {
      return <span className="menu-message-bubble">{messageCount}</span>;
    }
  };

  const pickImage = () => {
    const av = avatarURL ? avatarURL : buildImagePath('no_avatar_placeholder.svg?v=rb');
    return av;
  };

  const renderHostForum = (isBoxMenu) => {
    const listClass = isBoxMenu ? 'hidden-xl' : 'visible-xl';

    if (isHost) {
      return (
        <li className={`menu-forum ${listClass}`}>
          <a href="https://community.peerspace.com">
            <FormattedMessage
              id="shared_component.navbar.community_nav_item"
              defaultMessage="Community"
            />
          </a>
        </li>
      );
    }

    return null;
  };

  const renderAddons = (isBoxMenu) => {
    const badgeExp = some(nuxData, { name: 'addons-new-badge' });
    const listClass = isBoxMenu ? 'hidden-xl' : 'visible-xl';

    if (isHost) {
      return (
        <li className={`menu-item ${listClass}`}>
          <a className="nav-link" href="/hosting/add-ons">
            <FormattedMessage
              id="shared_component.navbar.addons_nav_item"
              defaultMessage="Add-ons"
            />
          </a>
          {
            badgeExp
              && <span className="v-center text-pale-blue text-small new-notification">
                <FormattedMessage
                  id="shared_component.navbar.notification_nav_badge"
                  defaultMessage="NEW!"
                />
              </span>
          }
        </li>
      );
    }

    return null;
  };

  const renderCalendar = (isMobile) => {
    const listClass = isMobile ? 'hidden-lg hidden-xl' : 'visible-lg visible-xl';
    const badgeExpComplete = some(nuxData, { name: 'calendar-new-badge' });
    if (isHost) {
      return (
        <li className={`menu-calendar ${listClass}`}>
          <a className="nav-link" href="/calendar">
            <FormattedMessage
              id="shared_component.navbar.calendar_nav_item"
              defaultMessage="Calendar"
            />
          </a>
          {
            !isEmpty(nuxData) && badgeExpComplete
              ? <span className="v-center text-pale-blue text-small new-notification">
                <FormattedMessage
                  id="shared_component.navbar.notification_nav_badge"
                  defaultMessage="NEW!"
                />
              </span> : null
          }
        </li>
      );
    }
    return null;
  };

  const renderLogo = () => {
    const translation = defineMessages({
      altText: {
        id: 'shared_component.navbar.logo_image_alt',
        defaultMessage: 'Peerspace | Unique venues for meetings, events, photo & film shoots'
      }
    });
    if (displaySearchNav) {
      return (
        <div className="flex middle">
          <a id="header_link_home" className="navbar-brand" href={ `/${prefix}` }>
            <picture>
              <source
                media="(max-width: 744px)"
                srcSet={buildImagePath('ps_logo_stack_white.svg?v=rb')}
                alt={intl.formatMessage(translation.altText)}
              />
              <img
                className="brand-logo-dark"
                src={buildImagePath('ps_logo_dark.svg?v=rb')}
                alt={intl.formatMessage(translation.altText)}
              />
            </picture>
          </a>
          <button
            id="header_search_button"
            className="btn btn-default btn-black search-button ellipsis text-small remove-click-styling flex middle"
            onClick={toggleSearchWidgetFn}
          >
            <SearchSmall className="margin-sm-right" width={20} height={20} />
            {`${searchActivity} • ${searchLocation}`}
          </button>
        </div>
      );
    }
    return (
      <a id="header_link_home" className="navbar-brand" href={ `/${prefix}` }>
        <img className="brand-logo-white" src={buildImagePath('ps_logo_white.svg?v=rb')}
          alt={intl.formatMessage(translation.altText)}/>
        <img className="brand-logo-dark" src={buildImagePath('ps_logo_dark.svg?v=rb')}
          alt={intl.formatMessage(translation.altText)}/>
      </a>
    );
  };

  const addFillerLocations = (browsePaths) => {
    const locations = browsePaths && browsePaths[0];
    if (!urlPrefix || !locations || (locations.children && 13 <= locations.children.length)) {
      return;
    }
    for (let i = 0; i < (availablePermalinks.locations || []).length; i++) {
      if (13 === locations.children.length) {
        break;
      }
      const currPermalink = availablePermalinks.locations[i];
      if (currPermalink.startsWith(urlPrefix)) {
        const permalinkSplit = currPermalink.split('--')[0].split('/');
        const cityName = permalinkSplit[permalinkSplit.length - 1];
        const cityNameTitleCase = cityName.split('-').map(
          w => w[0].toLocaleUpperCase() + w.slice(1)
        ).join(' ');
        const cityPresent = -1 < locations.children.findIndex(
          p => p.display.toLowerCase() === cityNameTitleCase.toLowerCase()
          || p.url === currPermalink
        );
        if (!cityPresent) {
          locations.children.splice(locations.children.length - 1, 0, {
            display: cityNameTitleCase,
            url: currPermalink,
            id: `${intl.locale}_${cityName}`
          });
        }
      }
    }
  };

  const getBrowsePaths = () => {
    if (!availablePermalinks) {
      return [];
    }
    const paths = cloneDeep(getNavbarBrowsePaths(intl) || {});
    const pathTypes = Object.keys(paths);
    const filteredPaths = pathTypes.reduce(
      (result, pathType) => {
        let currentActiveLinks;
        const currentPath = paths[pathType];
        if (
          'activities' === pathType
          || 'spaceTypes' === pathType
          || 'amenities' === pathType
        ) {
          currentActiveLinks = availablePermalinks.activities;
        } else if ('locations' === pathType) {
          currentActiveLinks = availablePermalinks.locations;
        } else if ('ideas' === pathType) {
          result.push(currentPath);
        }
        if (!currentActiveLinks || !currentActiveLinks.length) {
          return result;
        }
        // filter any items that don't include an available permalink
        currentPath.children = currentPath.children.filter(
          (path) => (
            path.id.includes('see_all')
            || currentActiveLinks.includes(path.url)
          )
        );
        result.push(currentPath);
        return result;
      }, []
    );
    addFillerLocations(filteredPaths);
    // remove any nested menu items that have no children
    return filteredPaths.filter(
      (browsePath) => browsePath.children && browsePath.children.length
    );
  };

  const lockBody = () => {
    if (!document.body.classList.contains('lock-body')) {
      document.body.classList.add('lock-body');
    } else {
      document.body.classList.remove('lock-body');
    }
  };

  return (
    <div>
      <div id="banner-container"></div>
      <div id="modal-container" className="modal fade" tabIndex="-1"></div>
      <nav data-loggedin={loggedIn} className={`navbar navbar-default ${fixedTop} ${navTransparentClass}`}
        id="main-nav" data-usr={userSSOID}
      >
        <span itemScope itemType="http://schema.org/Organization">
          <link itemProp="url" href={ `http://www.peerspace.com/${ prefix }` } />
          <meta itemProp="sameAs" content="http://www.facebook.com/Peerspace" />
          <meta itemProp="sameAs" content="http://www.x.com/Peerspace" />
          <meta itemProp="sameAs" content="http://www.pinterest.com/Peerspace" />
          <meta itemProp="sameAs" content="https://www.youtube.com/user/Peerspace" />
          <meta itemProp="sameAs" content="https://www.linkedin.com/company/3542206" />
          <meta itemProp="logo" content="http://res.cloudinary.com/peerspace-inc/image/upload/v1415919909/ps_images/peer_space_logo.png?v=rb" />
        </span>
        <div className="container-fluid">
          <div className="navbar-header">
            <div className={'nav-logged-out ' + loggedOut}>
              <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#listing-navbar" aria-expanded="false">
                <span className="sr-only">
                  <FormattedMessage
                    id="shared_component.navbar.toggle_nav_button"
                    defaultMessage="Toggle navigation"
                  />
                </span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
            </div>
            <div className={'nav-logged-in ' + loggedIn}>
              <button
                onClick={lockBody}
                type="button"
                className="logged-in navbar-toggle text-white"
                data-toggle="collapse"
                data-target="#listing-navbar"
                aria-expanded="false"
              >
                <span className="sr-only">
                  <FormattedMessage
                    id="shared_component.navbar.toggle_nav_button"
                    defaultMessage="Toggle navigation"
                  />
                </span>
                <img className="img-circle" src={pickImage()} />
                <ArrowDownSmall width={24} height={24}/>
              </button>
            </div>
            {renderLogo()}
            {
              !hideSearch
              && <ul className="nav navbar-nav nav-signup pull-right">
                {checkHideSearch()}
                {checkHideVerticalLine()}
                {checkHideSignUp()}
              </ul>
            }
          </div>
          <div className="collapse navbar-collapse" id="listing-navbar">
            <ul className={'nav navbar-nav navbar-right nav-logged-in ' + loggedIn}>
              <li className="hidden-menu-item">
                <a>
                  <LocaleSelector source="navbar" activeLocales={envLocaleData}>
                    <img className="nav-locale-selector-icon" src="https://assets.peerspace.com/globe.svg?v=rb"/>
                  </LocaleSelector>
                </a>
              </li>
              {
                showReferral
                    && [
                      <li key="referral" className="menu-item hidden-menu-item" onClick={sendReferralNavClickAnalytics}>
                        <a className="earn-more" href="/referrals" id="header_link_referrals">
                          <img style={{ width: 20, marginBottom: 6 }}
                            className="margin-md-right"
                            src="https://assets.peerspace.com/gift-primary.svg?v=rb"
                            alt="gift"
                          />
                          <span>
                            <FormattedMessage
                              id="shared_component.navbar.referral_nav_item"
                              defaultMessage="Earn $50"
                            />
                          </span>
                        </a>
                      </li>
                    ]
              }
              <li className="menu-messages hidden-menu-item">
                <a href="/inbox">
                  <FormattedMessage
                    id="shared_component.navbar.inbox_nav_item"
                    defaultMessage="Inbox"
                  />
                  {checkMessageBubble()}
                </a>
              </li>
              <li className="menu-bookings hidden-menu-item">
                <a href="/bookings">
                  <FormattedMessage
                    id="shared_component.navbar.bookings_nav_item"
                    defaultMessage="Bookings"
                  />
                </a>
              </li>
              { checkIsHost() }
              { renderCalendar() }
              { renderAddons() }
              { renderBoards() }
              { renderHostForum() }
              <li id="profileDropdown" className="dropdown profile-dropdown">
                <a href="#" className="dropdown-toggle profile-menu" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                  <img className="img-circle" src={pickImage()} />
                  <ArrowDownSmall width={24} height={24}/>
                </a>
                <ul className="dropdown-menu dropdown-menu-right profile-menu-dropdown">
                  <div className="arrow-up" />
                  <li className="visible-menu-item">
                    <a>
                      <LocaleSelector source="navbar" activeLocales={envLocaleData}>
                        <img className="nav-locale-selector-icon" src="https://assets.peerspace.com/globe.svg?v=rb"/>
                      </LocaleSelector>
                    </a>
                  </li>
                  <li className="visible-menu-item">
                    <a href="/inbox">
                      <FormattedMessage
                        id="shared_component.navbar.inbox_nav_item"
                        defaultMessage="Inbox"
                      />
                      {checkMessageBubble()}
                    </a>
                  </li>
                  <li className="visible-menu-item">
                    <a href="/bookings">
                      <FormattedMessage
                        id="shared_component.navbar.bookings_nav_item"
                        defaultMessage="Bookings"
                      />
                    </a>
                  </li>
                  { checkIsHost(true) }
                  { renderCalendar(true) }
                  { renderAddons(true) }
                  { renderHostForum(true) }
                  <li><a href="/reviews/about-you">
                    <FormattedMessage
                      id="shared_component.navbar.reviews_nav_item"
                      defaultMessage="Reviews"
                    />
                  </a></li>
                  { renderBoards(true) }
                  <li><a href="/profile">
                    <FormattedMessage
                      id="shared_component.navbar.profile_nav_item"
                      defaultMessage="Profile"
                    />
                  </a></li>
                  <li><a href="/account">
                    <FormattedMessage
                      id="shared_component.navbar.payments_nav_item"
                      defaultMessage="Payments"
                    />
                  </a></li>
                  {
                    showReferralForHost
                    && [
                      <li key="separator" role="separator" className={`divider ${!isHost && 'visible-menu-item'}`}/>,
                      <li key="referral" onClick={sendReferralNavClickAnalytics} className={`${!isHost && 'visible-menu-item'}`}>
                        <a className="earn-more" href="/referrals" id="menu_link_referrals">
                          <img style={{ width: 20, marginBottom: 6 }}
                            className="margin-md-right"
                            src="https://assets.peerspace.com/gift-primary.svg?v=rb"
                            alt="gift"
                          />
                          <span>
                            <FormattedMessage
                              id="shared_component.navbar.referral_nav_item"
                              defaultMessage="Earn $50"
                            />
                          </span>
                        </a>
                      </li>
                    ]
                  }
                  <li role="separator" className="divider"></li>
                  <li><a className="add-a-space-menu" href="/host">
                    <FormattedMessage
                      id="shared_component.navbar.list_your_space_nav_item"
                      defaultMessage="List Your Space"
                    />
                  </a></li>
                  <li><a href={`https://support.peerspace.com/hc/${zenDeskLocale}`}>
                    <FormattedMessage
                      id="shared_component.navbar.help_nav_item"
                      defaultMessage="Help"
                    />
                  </a></li>
                  <li onClick={logOutUser}>
                    <a className="logout">
                      <FormattedMessage
                        id="shared_component.navbar.logout_nav_item"
                        defaultMessage="Log Out"
                      />
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
            <ul className={'nav navbar-nav navbar-right nav-logged-out ' + loggedOut}>

              <li>
                <a>
                  <LocaleSelector source="navbar" activeLocales={envLocaleData}>
                    <img
                      className="nav-locale-selector-icon"
                      src="https://assets.peerspace.com/globe.svg?v=rb"
                    />
                  </LocaleSelector>
                </a>
              </li>
              <li className="browse-spaces-dropdown">
                <DropdownMenu menuTree={getBrowsePaths()}>
                  <FormattedMessage
                    id="shared_component.navbar.browse_spaces_nav_item"
                    defaultMessage="Browse Spaces"
                  />
                </DropdownMenu>
              </li>
              <li>
                <a id="header_link_add_space" className="add-a-space" href={ `${ urlPrefix }/host` }>
                  <FormattedMessage
                    id="shared_component.navbar.list_your_space_nav_item"
                    defaultMessage="List Your Space"
                  />
                </a>
              </li>
              <li>
                <a id="header_link_signup" href="#a=signup&source=nav">
                  <FormattedMessage
                    id="shared_component.navbar.signup_nav_item"
                    defaultMessage="Sign Up"
                  />
                </a>
              </li>
              <li>
                <a id="header_link_signin" href="#a=login">
                  <FormattedMessage
                    id="shared_component.navbar.login_nav_item"
                    defaultMessage="Log In"
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
});
